import { createUseStyles } from 'react-jss'

import { colors } from '../variables.style'

const pageTitleStyle = {
  maxWidth: 460,
  textOverflow: 'ellipsis',
  overflowX: 'hidden'
}

export const style = {
  rowContainer: {
    marginLeft: 16
  },
  draggableRowContainer: {
    minHeight: 38
  },
  row: {
    composes: 'flex-row',
    marginBottom: 16
  },
  draggableRow: {
    composes: 'flex-row',
    backgroundColor: colors.backgroundGray,
    border: `1px solid ${colors.brandDark}`,
    marginBottom: 6
  },
  pageNumber: {
    fontFamily: 'Raleway',
    fontVariantNumeric: 'lining-nums',
    fontSize: 15,
    flex: '0 0 34px',
    marginTop: 2
  },
  pageLink: {
    composes: 'flex-auto link',
    fontSize: 16,
    ...pageTitleStyle
  },
  currentReport: {
    composes: 'flex-auto',
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.brandAccent
  },
  currentPageNumber: {
    extend: 'pageNumber',
    color: colors.brandAccent
  },
  grabber: {
    padding: 8
  },
  draggableTitle: {
    padding: '8px 8px 8px 0',
    lineHeight: '0.9em',
    ...pageTitleStyle
  }
}

export const useStyles = createUseStyles(style)
